import { FC, Fragment, ReactNode } from 'react';
import { useRecoilValue } from 'recoil';
import { UserRole } from 'TaxAnalyticsHelpers/TaxAnalyticsClient';
import { userState } from 'TaxAnalyticsState/userState';

export interface IDisplayProps {
    roles: UserRole[];
    children?: ReactNode;
}

export const Display: FC<IDisplayProps> = (props: IDisplayProps) => {
    const user = useRecoilValue(userState);
    if (props.roles.find(r => r === user?.user?.role))
        return (
            <Fragment>
                {props.children}
            </Fragment>
        );
    return null;
}